require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ../~/angular-cookies/index.js
// module id = 50
// module chunks = 0